import { render, staticRenderFns } from "./MilkHome.vue?vue&type=template&id=3febd134&"
import script from "./MilkHome.vue?vue&type=script&lang=js&"
export * from "./MilkHome.vue?vue&type=script&lang=js&"
import style0 from "./MilkHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports